var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:[
            `relative focus:outline-none`,
            _vm.blockClass,
            _vm.textClass,
            _vm.sizeClass,
            _vm.typeClass,
            _vm.backgroundClass,
            _vm.disabledClass,
            _vm.roundedClass,
            _vm.shadowClass,
        ],attrs:{"disabled":_vm.isDisabled,"type":"button"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"whitespace-nowrap"},[(_vm.iconPosition === 'right')?_vm._t("default"):_c('span')],2),(_vm.icon && !_vm.block)?_c('v-icon',{class:[_vm.iconPosition === 'left' ? 'mr-2' : 'ml-2'],attrs:{"size":"5","type":_vm.icon}}):_vm._e(),_c('span',{staticClass:"whitespace-nowrap"},[(_vm.iconPosition === 'left')?_vm._t("default"):_c('span')],2),(_vm.loading)?_c('v-loading-in-place',{class:`absolute inline ${_vm.loadingPadding} mr-2`,attrs:{"size":_vm.loadingSize}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }